(() => {
  const schema = 'https://schema.org/';
  for (const script of document.querySelectorAll('[data-poto-product-schema]')) {
    if (script.dataset.enriched) continue;
    let product;
    try { product = JSON.parse(script.textContent); } catch { continue; }
    if (!['Product', 'ProductGroup'].includes(product['@type'])) continue;
    script.dataset.enriched = 'true';
    if (!product.description && script.dataset.description) product.description = script.dataset.description;
    const variants = product.hasVariant || [product];
    const save = () => { script.textContent = JSON.stringify(product).replace(/</g, '\\u003c'); };
    if (typeof product.name === 'string' && Array.from(product.name).length > 150) {
      product.name = Array.from(product.name).slice(0, 147).join('') + '...';
    }
    for (const variant of variants) {
      if (!variant.description && product.description) variant.description = product.description;
      if (typeof variant.name === 'string' && Array.from(variant.name).length > 150) {
        variant.name = Array.from(variant.name).slice(0, 147).join('') + '...';
      }
      const offers = Array.isArray(variant.offers) ? variant.offers : [variant.offers];
      for (const offer of offers) {
        if (!offer || offer['@type'] !== 'Offer') continue;
        offer.hasMerchantReturnPolicy ||= {
          '@type': 'MerchantReturnPolicy', applicableCountry: 'US',
          returnPolicyCategory: schema + 'MerchantReturnFiniteReturnWindow',
          merchantReturnDays: 14, returnMethod: schema + 'ReturnByMail',
          returnFees: schema + 'ReturnFeesCustomerResponsibility',
          merchantReturnLink: script.dataset.returnUrl
        };
        if (offer.priceCurrency === 'USD' && Number.isFinite(Number(offer.price))) {
          offer.shippingDetails ||= {
            '@type': 'OfferShippingDetails',
            shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'US' },
            shippingRate: { '@type': 'MonetaryAmount', currency: 'USD', value: Number(offer.price) >= 30 ? 0 : 5 },
            deliveryTime: {
              '@type': 'ShippingDeliveryTime',
              handlingTime: { '@type': 'QuantitativeValue', minValue: 3, maxValue: 3, unitCode: 'DAY' },
              transitTime: { '@type': 'QuantitativeValue', minValue: 1, maxValue: 9, unitCode: 'DAY' }
            }
          };
        }
      }
    }
    save();
    if (script.dataset.reviews === 'false') continue;
    const connectReviews = () => {
      const widget = document.querySelector(`poto-reviews[data-product="${script.dataset.productId}"]`);
      if (!widget) return false;
      const handled = new WeakSet();
      const update = async () => {
        const list = widget.querySelector('[data-list]');
        if (!list || list.getAttribute('aria-busy') === 'true') return;
        const request = widget.pages?.get(widget.page);
        if (!request || handled.has(request)) return;
        handled.add(request);
        try {
          const data = await request;
          if (!Number.isInteger(data.total) || data.total <= 0 || !Number.isFinite(data.average) || data.average < 1 || data.average > 5) return;
          const reviews = (data.reviews || []).filter(review =>
            typeof review.author === 'string' && review.author.trim() &&
            Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5
          ).map(review => {
            const content = widget.i18n.reviewText(review, false);
            const result = {
              '@type': 'Review', author: { '@type': 'Person', name: review.author },
              reviewRating: { '@type': 'Rating', ratingValue: review.rating, bestRating: 5, worstRating: 1 }
            };
            if (content.body) result.reviewBody = content.body;
            if (content.title) result.name = content.title;
            if (/^\d{4}-\d{2}-\d{2}$/.test(review.reviewDay)) result.datePublished = review.reviewDay;
            return result;
          }).filter(review => review.reviewBody || review.name);
          product.aggregateRating = { '@type': 'AggregateRating', ratingValue: data.average, reviewCount: data.total, bestRating: 5, worstRating: 1 };
          if (reviews.length) product.review = reviews;
          else delete product.review;
          save();
        } catch { }
      };
      new MutationObserver(update).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
      update();
      return true;
    };
    const waitForReviews = () => {
      if (connectReviews()) return;
      const observer = new MutationObserver(() => {
        if (connectReviews()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForReviews, { once: true });
    else waitForReviews();
  }
})();
